module.exports = __webpack_public_path__ + "fonts-e6b0f014acc5db19c5cc6c5d729b36dc-GT-Eesti-Pro-Display-Regular-subset.zopfli.woff";